import { styled } from '@mui/material';
import { TextField } from 'components/TextField';

const TextFieldStyled = styled(TextField, {
  shouldForwardProp: (prop: string) => !['textSecure'].includes(prop)
})<{ textSecure: boolean }>`
  ${({ textSecure }) => textSecure && '-webkit-text-security: disc'};
`;

export default TextFieldStyled;
